module.exports = __webpack_public_path__ + "img/13_windAndRain_zj.23ef171f.png";